const EventTitles = {
  'AppWrapper.ToolbarButtonTap': 'AppWrapper.ToolbarButtonTap',
  toolbarBackButtonShow: 'toolbar-back-button-show',
  toolbarBackButtonHide: 'toolbar-back-button-hide',
  toolbarShow: 'toolbar-show',
  toolbarHide: 'toolbar-hide',
  toolbarTitleShow: 'toolbar-title-show',
  toolbarTitleHide: 'toolbar-title-hide',
  toolbarTitleUpdate: 'toolbar-title-update',
  surveyOpen: 'app-wrapper-open-survey',
  contentLoad: 'app-wrapper-load-content',
  setModalEvent: 'app-wrapper-set-modal',
  setBackBtnEvent: 'app-back-button',
  goBackEvent: 'app-go-back',
  loadingShow: 'loading-show',
  loadingHide: 'loading-hide',
  modalButtonTap: 'modal-button-tap',
  modalShow: 'modal-show',
  modalHide: 'modal-hide',
  menuBadgeUpdate: 'menu-badge-update',
  menuItemEnable: 'menu-item-enable',
  menuItemDisable: 'menu-item-disable',
  callbackRegistryDelegate: 'callback-registry-delegate',
  callbackRegistryResolve: 'callback-registry-resolve',
  showToast: 'show-toast',
  getAppConfig: 'get-app-config',
  loadAppFromAppLauncher: 'load-app-from-app-laucher'
}

export default {
  TOOLBAR_BUTTON_TAP: 'TOOLBAR_BUTTON_TAP'
}

export { EventTitles }
